import { render, staticRenderFns } from "./WageCalculationScheme.vue?vue&type=template&id=5418eb98&scoped=true"
import script from "./WageCalculationScheme.vue?vue&type=script&lang=ts"
export * from "./WageCalculationScheme.vue?vue&type=script&lang=ts"
import style0 from "./WageCalculationScheme.vue?vue&type=style&index=0&id=5418eb98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5418eb98",
  null
  
)

export default component.exports